import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MetadataCardProps {
  icon: LucideIcon;
  iconColor: string;
  label: string;
  children: React.ReactNode;
}

export function MetadataCard({
  icon: Icon,
  iconColor,
  label,
  children,
}: MetadataCardProps) {
  return (
    <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
      <Icon className={`w-5 h-5 ${iconColor}`} />
      <div className="flex flex-col gap-1.5">
        <div className="text-xs text-gray-500">{label}</div>
        {children}
      </div>
    </div>
  );
}
